import React from 'react'
import { subscribe } from 'react-contextual'
import { CurrencyText } from '../../../../../../views/components'
import ConsolidatedBalanceProvider from './ConsolidatedBalanceProvider'

const ConsolidatedBalance = ({ balance }: any) => {
  return (
    <section>
      <header>
        <span>Available funds</span>
        <span>
          <CurrencyText>{balance || 0}</CurrencyText>
        </span>
      </header>
    </section>
  )
}

export default subscribe(ConsolidatedBalanceProvider, ({ balance }: any) => ({ balance }))(ConsolidatedBalance)
